(ns dashboard.components.answer-options)

(defn Options [options on-change]
  (let [read-only (nil? on-change)]
    [:div
     (for [{:keys [id content multi selected]} options]
       [:div.is-flex
        {:key id}
        [:input
         (cond-> {:type (if multi
                          "checkbox"
                          "radio")
                  :checked selected
                  :read-only read-only
                  :disabled read-only}
           on-change (assoc :on-change #(on-change multi id)))]
        [:span.ml-2.text-layout
         content]])]))

(defn AnswerOptions [{:keys [options on-change]}]
  (let [{:keys [radio-buttons checkboxes]} (group-by #(if (:multi %) :checkboxes :radio-buttons) options)
        show-group-titles? (and (seq radio-buttons)
                                (seq checkboxes))]
    [:div
     (when show-group-titles?
       [:span.has-text-weight-bold "Single select options"])
     [Options radio-buttons on-change]
     (when show-group-titles?
       [:span.has-text-weight-bold "Multi select options"])
     [Options checkboxes on-change]]))
